export default __webpack_public_path__ + "static/simi-hustler-e41ea6af9e1b032774548a2d1c1ab44e.png";